// src/pages/CategoryPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import ProductCatalogSection from '../components/admin/page-sections/ProductCatalogSection';

const CategoryPage = () => {
  const { categorySlug } = useParams();
  
  // Format category name from slug
  const formatCategoryName = (slug) => {
    if (!slug) return 'Products';
    return slug
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  // Create a complete configuration object with ALL necessary properties
  const catalogConfig = {
    // Essential settings for CategoryPage
    initialCategorySlug: categorySlug,
    title: formatCategoryName(categorySlug),
    description: 'Browse our selection of quality products',
    backgroundColor: '#f8fafc',

    // Search settings
    showSearch: true,
    searchPlaceholder: `Search products...`,
  
      
    // FORCE showing all categories - override any default behavior
    showAllCategories: true,
    
    // Include empty selectedCategoryIds array to ensure no filtering
    selectedCategoryIds: [],
    
    // Other essential display settings
    showCategorySlider: true,
    showSearch: true,
    categoryDisplayMode: 'slider',
    categoryItemSize: 'large',
    categoryShape: 'circle',
    categoryTextPosition: 'below',
    categoryTextColor: '#ffffff',
    categoryOverlayOpacity: '0.7',
    categoryHoverEffect: 'zoom',
    categoryBorderColor: '#3B82F6',
    selectedCategoryBorderColor: '#F59E0B',
    
      
    // Product display settings
    productsPerRow: 3,
    productCardStyle: 'shadow',
    productDisplayFields: {
      showName: true,
      showPrice: true,
      showDescription: false,
      showNote: false,
      showRating: false
    },
    productInfoPosition: 'below',
    productTextAlignment: 'left',
    productNameLines: 2,
    productDescriptionLines: 3,
    productImageAspectRatio: 'square',
    
    // Product interaction
    showQuickAction: false,
    quickActionIcon: 'customize',
    productClickBehavior: 'navigate', // 'navigate' or 'popup'
    productPopupSettings: {
      showGallery: true,
      showDescription: true,
      showPrice: false,
      showNote: true,
      showAttributes: true,
      showAddToCart: false,
      showCustomizeButton: false,
      popupSize: 'medium'
    },

    // API paths - explicitly set to ensure correct data fetching
    categoryApiPath: '/api/categories',
    productApiPath: '/api/products/basic'
  };
  
  return (
    <div>
      <ProductCatalogSection content={catalogConfig} />
    </div>
  );
};

export default CategoryPage;




// // working with no selection category in productcatalogsection
// // if rolling back to that version, use this one
// // src/pages/CategoryPage.js
// import React from 'react';
// import { useParams } from 'react-router-dom';
// import ProductCatalogSection from '../components/admin/page-sections/ProductCatalogSection';

// const CategoryPage = () => {
//   const { categorySlug } = useParams();
  
//   return (
//     <div>
//       <ProductCatalogSection 
//         content={{ 
//           initialCategorySlug: categorySlug,
//           title: 'Products'
//         }} 
//       />
//     </div>
//   );
// };

// export default CategoryPage;